/* eslint-disable no-debugger */
import { Fragment } from "react";
import StandardKendoReport from "@usas/ui-web/components/embeddedReports/kendoReports/StandardKendoReport";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import useRelayTimesDetailKendoReport from "./UseRelayTimesDetailKendoReport";
import DatePicker from "@usas/ui-web/components/datepickers/DatePicker";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import EventMultiSelect from "@usas/ui-web/components/multiSelect/eventMultiSelect/EventMultiSelect";
import CourseMultiSelect from "@usas/ui-web/components/multiSelect/courseMultiSelect/CourseMultiSelect";
import CompetitionCategoryMultiSelect from "@usas/ui-web/components/multiSelect/competitionCategoryMultiSelect/CompetitionCategoryMultiSelect";
import ZoneMultiSelect from "@usas/ui-web/components/multiSelect/zoneMultiSelect/ZoneMultiSelect";
import LscMultiSelect from "@usas/ui-web/components/multiSelect/lscMultiSelect/LscMultiSelect";
import ClubMultiSelect from "@usas/ui-web/components/multiSelect/clubMultiSelect/ClubMultiSelect";
// import NTGroupOfficialRosterCombobox from "../../components/comboboxes/ntGroupOfficialRosterCombobox/NtGroupOfficialRosterCombobox";

import Dropdown from "@usas/ui-web/components/dropdowns/Dropdown";
import Input from "@usas/ui-web/components/inputs/Input";
import YesNoSwitch from "@usas/ui-web/components/yesNoSwitch/YesNoSwitch";
import Headings from "@usas/ui-web/components/headings/Headings";
import QuestionIcon from "@usas/ui-web/components/icons/QuestionIcon";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import style from "../kendoReports/shared/KendoReport.module.css";

// NOTE: if you have are using basic single select parameters like DDLs and textboxes you can dynamically gerenerate the parametes from json.
// see ClubTimesNew.jsx. If you want to use a specic complex component like EventMultiSelect you can create a form as in this example.

const RelayTimesDetailKendoReport = () => {
  const {
    formState,
    errorState,
    reportParameters,
    parameters,
    columns,
    modalState,
    onModalCancelClicked,
    handleSubmit,
    onFormValueChanged,
    onValueTextPairChanged,
    updateFormState,
    onRunReportClicked,
    onClearForm,
    seasonYearState,
    excelColumns
  } = useRelayTimesDetailKendoReport();

  return (
    <Fragment>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row">
          <div className="col-xs-12">
            <Headings.H3>Relay Times Detail Report</Headings.H3>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            <ZoneMultiSelect
              label={<span>Zones&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all zones." /></span>}
              name="zones"
              value={formState.zones}
              error={errorState.zones}
              message={errorState.zones}
              onChange={(value) => {
                onFormValueChanged('zones', value);
                onFormValueChanged('lscs', []);
                onFormValueChanged('clubs', []);
              }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <LscMultiSelect
              label={<span>LSCs&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all LSCs." /></span>}
              name="lscs"
              value={formState.lscs}
              error={errorState.lscs}
              message={errorState.lscs}
              filterIds={formState.zones.map(c => c.id).join(',')}
              onChange={(value) => {
                onFormValueChanged('lscs', value);
                onFormValueChanged('clubs', []);
              }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <ClubMultiSelect
              label={<span>Clubs&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all clubs." /></span>}
              name="clubs"
              value={formState.clubs}
              error={errorState.clubs}
              message={errorState.clubs}
              filterIds={formState.lscs.map(c => c.id).join(',')}
              onChange={(value) => { onFormValueChanged('clubs', value); }} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            <CourseMultiSelect
              label={<span>Courses&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all courses." /></span>}
              name="courses"
              value={formState.courses}
              error={errorState.courses}
              message={errorState.courses}
              includeOpenWater={false}
              onChange={(value) => {
                onFormValueChanged('courses', value);
                onFormValueChanged('events', []);
              }}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <EventMultiSelect
              label={<span>Events&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all events." /></span>}
              name="events"
              value={formState.events}
              error={errorState.events}
              message={errorState.events}
              filterIds={formState.courses.map(c => c.id).join(',')}
              isRelay={true}
              onChange={(value) => { onFormValueChanged('events', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <CompetitionCategoryMultiSelect
              label={<span>Competition Categories&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all competition categories." /></span>}
              name="competitionCategories"
              value={formState.genders}
              error={errorState.genders}
              message={errorState.genders}
              onChange={(value) => { onFormValueChanged('genders', value); }} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            <Dropdown
              label={<span>Season Year&nbsp;&nbsp;<QuestionIcon toolTipText="If you select a Season Year, do not enter a date range." /></span>}
              name="season"
              options={seasonYearState.options}
              value={formState.seasonId}
              error={errorState.seasonId}
              message={errorState.seasonId}
              isLoading={seasonYearState.isLoading}
              onChange={(newValue, newValueLabel, e) => {
                e && e.target && e.target.value &&
                  onValueTextPairChanged(newValue, 'seasonId', newValueLabel, 'seasonYear', e);
              }} />

          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <DatePicker
              label={<span>Start Date&nbsp;&nbsp;<QuestionIcon toolTipText="If you select a Start Date, do not enter a Season Year." /></span>}
              name="startDate"
              value={formState.startDate}
              error={errorState.startDate}
              message={errorState.startDate}
              countOfYears={150}
              startYearOffset={-149}
              onChange={(value) => { updateFormState('startDate', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <DatePicker
              label="End Date"
              name="endDate"
              value={formState.endDate}
              error={errorState.endDate}
              message={errorState.endDate}
              countOfYears={150}
              startYearOffset={-149}
              onChange={(value) => { updateFormState('endDate', value); }} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            <Input
              label="Min Age"
              name="minAge"
              type="number"
              min="1"
              max="99"
              value={formState.minAge}
              error={errorState.minAge}
              message={errorState.minAge}
              onChange={(value) => { onFormValueChanged('minAge', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <Input
              label="Max Age"
              name="maxAge"
              type="number"
              min="1"
              max="99"
              value={formState.maxAge}
              error={errorState.maxAge}
              message={errorState.maxAge}
              onChange={(value) => { onFormValueChanged('maxAge', value); }} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            <YesNoSwitch
              label="Exclude NCAA Times"
              name="excludeNcaa"
              checked={formState.excludeNcaa === true}
              error={errorState.excludeNcaa}
              message={errorState.excludeNcaa}
              value={formState.excludeNcaa}
              onChange={(value) => { updateFormState('excludeNcaa', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <Input
              label={<span>Top Times&nbsp;&nbsp;<QuestionIcon toolTipText="Maximum input of 100." /></span>}
              name="topTimes"
              type="number"
              min="1"
              max="100"
              value={formState.topTimes}
              error={errorState.topTimes}
              message={errorState.topTimes}
              onChange={(value) => { onFormValueChanged('topTimes', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <YesNoSwitch
              label="Export Detail Data to Excel"
              name="exportDetailData"
              checked={formState.exportDetailData === true}
              error={errorState.exportDetailData}
              message={errorState.exportDetailData}
              value={formState.exportDetailData}
              onChange={(value) => { updateFormState('exportDetailData', value); }} />
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={(e) => onRunReportClicked(e)}>Run</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={() => onClearForm()}>Clear Form</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        className={style.reportModalTop}
        widthPct={98}
        maxWidth={2050}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCancelClicked}>
        <StandardKendoReport
          reportInfoId={284}
          reportParameters={reportParameters}
          title="Relay Times Detail Report"
          parameters={parameters}
          columns={columns}
          usePagination={false}
          pageSize={10}
          enablePdfExport={true}
          enableExcelExport={true}
          gridHeight="750px"
          detailArrayName="splits"
          detailReportTitle="Relay Legs"
          detailGridHeight="160px"
          excelColumns={excelColumns}
          exportDetailData={formState.exportDetailData}
        />
      </PopUpModal>
    </Fragment>
  );
}

export default RelayTimesDetailKendoReport;